export interface NameParts {
  lastName: string;
  firstName: string;
  middleName?: string | null;
  suffix?: string | null;
}

export const formatNameLastFirstMiddleSuffix = (name: NameParts, isLastUpper = true): string => {
  const lastName = isLastUpper ? name.lastName.toUpperCase() : name.lastName;
  const middleName = name.middleName ? ' ' + name.middleName : '';
  const suffix = name.suffix ? ', ' + name.suffix : '';
  return `${lastName}, ${name.firstName}${middleName}${suffix}`;
};
